exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Title-module__title___2CJuL{max-width:100%;overflow:hidden;text-overflow:ellipsis}@media (max-width:800px){.Title-module__title___2CJuL{font-size:24px;line-height:32px}}", ""]);

// exports
exports.locals = {
	"title": "Title-module__title___2CJuL"
};